<template>
  <div class="sellertip">
    <!-- <z-upload v-model="files"
              ref="upload"
              :action="action"
              :process-file="processFile"
              :accept="accept"
              :max="max" />
    </z-upload-btn>
    <div v-for="item in files">
      <div>图片链接{{item.status}}</div>
      <div>图片链接{{item.url}}</div>
      <div>文件对象{{item}}</div>
    </div> -->
    <div class="capture">
      <z-upload
        v-model="files"
        ref="upload"
        :max="max"
        isAdaptIosUplaod
        :capture="capture"
        :process-file="processFile"
        @file-success="fileSuccess"
      >
        <z-upload-file v-for="(file, i) in files" :file="file" :key="i" />
        <div class="camera">
          <z-upload-btn class="camera" v-if="showBtn">
            <div class="id-card">
              <div class="sample-cover"></div>
            </div>
          </z-upload-btn>
          <div class="right-info">
            <span style="color: red">*</span>{{ `请您拍摄本人（曹清达）手持身份证照片` }}
          </div>
        </div>
      </z-upload>
      <div v-for="(item, index) in files" :key="index">
        <div>图片链接{{ item.status }}</div>
        <div>图片链接{{ item.urlName }}</div>
        <z-button type="primary" @click="showFile(item)">主要按钮! </z-button>
      </div>
    </div>
    <!-- <z-upload v-model="files"
              ref="upload"
              :max="max"
              isAdaptIosUplaod
              :process-file="processFile"
              :action="action"
              @file-success="fileSuccess">
      <div class="clear-fix">
        <z-upload-file v-for="(file, i) in files"
                       :file="file"
                       :key="i" />
        <z-upload-btn v-if="showBtn">
          <div>
            <i>＋</i>
            <p>Please click to upload ID card</p>
          </div>
        </z-upload-btn>
      </div>
      <div v-for="item in files">
        <div>图片链接{{item.status}}</div>
        <div>图片链接{{item.url}}</div>
        <div>文件对象{{item}}</div>
      </div>
    </z-upload> -->
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Upload, Button } from '@zz-common/zz-ui'
import compress from '@zz-common/zz-ui/lib/utils/image'

export default {
  name: 'SellerTip',
  data() {
    return {
      // action: { target: 'https://upload.58cdn.com.cn/json?rand=0.1928', zz: true },
      accept: 'image/*',
      max: 1,
      zzapp: true,
      capture: true,
      files: [],
      Twofiles: []
    }
  },
  computed: {
    showBtn() {
      return this.max > this.files.length
    }
  },
  components: {
    zUpload: Upload,
    zUploadBtn: Upload.Btn,
    zUploadFile: Upload.File,
    zButton: Button
  },
  methods: {
    showFile(item) {
      console.log('file', item)
    },
    fileSuccess(files) {
      // const file = this.Twofiles[0]
      // file && this.$refs.upload.removeFile(file);
      console.log('fileUrl', files.url)
    },
    errHandler(_file) {
      // const msg = file.response.message
      console.log('Upload fail')
    },
    processFile(file, next) {
      compress(
        file,
        {
          compress: true // 开启图片压缩，提高上传的速度，同时修正图片方向修正的问题
        },
        next
      )
    }
  },
  mounted() {
    native.setTitle({
      title: '上传Demo'
    })
  },
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
